// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1622":"f4d8b239","3447":"989cd4c2","7922":"e18244a6","8865":"d1e97181","9626":"c133e155"}[chunkId] + ".chunk.css";
};